// extracted by mini-css-extract-plugin
export default {"signed-in":"HeaderMainsite_signed-in__PCqPG"};